import { render } from "./accessories.vue?vue&type=template&id=d783f2d4&scoped=true"
import script from "./accessories.vue?vue&type=script&lang=js"
export * from "./accessories.vue?vue&type=script&lang=js"

import "./accessories.vue?vue&type=style&index=0&id=d783f2d4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d783f2d4"]])

export default __exports__